import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ActionApprovalPanel, ActionDeclinePanel } from './panels/action';

interface Props {
  id: string;
  title: string;
}

enum PanelOption {
  DECLINE = 'decline',
  APPROVE = 'approve',
}

export function ActionDetailsApprovalButtons({ id, title }: Props) {
  const { t } = useTranslation('issue');

  const [selectedActionPanel, setSelectedActionPanel] =
    useState<PanelOption | null>(null);

  return (
    <>
      <Stack direction='row' spacing={3}>
        <Button
          onClick={() => setSelectedActionPanel(PanelOption.DECLINE)}
          variant='outlined'
          data-testid='open-decline-panel'
        >
          {t('manage.decline.accept')}
        </Button>
        <Button
          onClick={() => setSelectedActionPanel(PanelOption.APPROVE)}
          variant='contained'
          data-testid='change-status-button'
        >
          {t('manage.approve.accept')}
        </Button>
      </Stack>
      <ActionApprovalPanel
        actionId={id}
        actionTitle={title}
        isOpen={selectedActionPanel === PanelOption.APPROVE}
        onClose={() => setSelectedActionPanel(null)}
        data-testid='change-status-approve-button'
      />
      <ActionDeclinePanel
        actionId={id}
        actionTitle={title}
        isOpen={selectedActionPanel === PanelOption.DECLINE}
        onClose={() => setSelectedActionPanel(null)}
      />
    </>
  );
}
